import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import isClinical from "../../../../common/helpers/isPortal";
import Btn from "../../../atoms/Btn";
import SourceEntity from "../../models/SourceEntity";
import Contribution from "../../../../models/Contribution";
import { getPubmedEntriesPerArticle } from "../../../../state/selectors/PubmedUserEntries.selectors";
import PathogenicityPieChart from "../../../social/PathogenicityPieChart";
import Article from "../../models/Article";

function ClassificationButton({
  article,
  sourceEntity,
  onSelect,
  isActive,
  contributions,
  showLabel,
  className,
  size,
}) {
  const isHidden = isClinical();

  const sb = sourceEntity.type;
  const msg = `Classifications related to this ${sb}`;
  const colorClass = isActive
    ? "tw-text-blue-500"
    : "tw-text-blueGray-700 tw-opacity-60 hover:tw-opacity-100";

  return isHidden ? null : (
    <div
      className={`tw-text-center tw-flex tw-items-center tw-relative ${colorClass}`}
    >
      <Btn
        onSubmit={onSelect}
        data-tooltip={msg}
        data-tooltip-delay={700}
        data-tooltip-class="publications-tooltip"
        className="tw-flex tw-items-center"
      >
        <PathogenicityPieChart
          sourceEntity={sourceEntity}
          pubmedId={article.pubmedId}
          className={className}
          size={size}
        />

        <div className="tw-w-1" />
        {showLabel ? (
          <div>
            {contributions.length} classification
            {contributions.length === 1 ? "" : "s"}
          </div>
        ) : (
          contributions.length
        )}
      </Btn>
    </div>
  );
}

ClassificationButton.propTypes = {
  isActive: PropTypes.bool,
  sourceEntity: PropTypes.instanceOf(SourceEntity),
  onSelect: PropTypes.func,
  contributions: PropTypes.arrayOf(PropTypes.instanceOf(Contribution)),
  article: PropTypes.instanceOf(Article).isRequired,
  showLabel: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.number,
};

ClassificationButton.defaultProps = {
  contributions: [],
  onSelect: () => {},
  isActive: false,
  sourceEntity: null,
  showLabel: true,
  className: "tw-w-6 tw-h-6",
  size: 18,
};

const mapStateToProps = (state, props) => {
  const { article, sourceEntity } = props;
  const { id: entId } = sourceEntity || {};
  const entryMap = getPubmedEntriesPerArticle(state) || new Map();
  const pubEntries = entryMap.get(String(article.pubmedId)) || [];
  const contributions = pubEntries.filter((x) => x.variantId === entId);
  return { contributions, article };
};

export default React.memo(connect(mapStateToProps, {})(ClassificationButton));
